import script from "./AudioItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioItem.vue?vue&type=script&setup=true&lang=ts"

import "./AudioItem.vue?vue&type=style&index=0&id=e7f4ac18&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7f4ac18"]])

export default __exports__